import React from 'react'
import icons from './../../../utils/import.icons'
import mobileAndTabletCheck from './../../../utils/mobileCheck'


let imageSize = ["100vw", "100vh"];
let barOffset = 0;
if (mobileAndTabletCheck() && window.innerHeight > window.innerWidth) {
  barOffset = 5;
  imageSize = ["calc(84vh * 1.77778)", "84vh"];
}

let Amenities: any = [[{
    name:"Spa",
    tipo:"Spa",
    verts:[[285.987,565.802]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[300.55,588.407]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[326.637,584.413]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[700.901,586.471]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[749.408,752.656]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[837.738,471.684]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1220.57,398.201]]
    },],[{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[39.9584,496.631]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[305.031,544.345]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[315.403,566.216]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[329.887,562.865]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[680.811,576.581]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[682.838,738.053]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[847.04,469.149]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1247.9,406.433]]
    },],[{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[107.164,475.552]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[331.796,526.461]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[338.357,547.233]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[342.757,543.824]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[623.744,718.705]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[664.667,567.179]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[855.625,469.61]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1269.1,418.773]]
    },],[{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[173.737,460.106]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[360.429,527.82]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[361.491,512.194]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[364.679,531.695]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[572.007,697.192]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[650.722,558.546]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[861.989,471.959]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1283.28,433.251]]
    },],[{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[236.128,448.938]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[379.436,514.589]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[390.888,500.899]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[391.125,519.107]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[526.771,675.513]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[637.707,550.653]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[865.443,475.081]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1290.48,448.15]]
    },],[{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[292.839,440.539]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[397.756,503.455]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[415.92,508.652]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[418.267,491.659]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[486.962,654.836]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[624.928,543.28]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[865.99,478.086]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1291.51,462.275]]
    },],[{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[343.539,433.489]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[414.301,493.604]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[438.217,499.438]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[442.85,483.52]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[451.334,635.728]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[612.029,536.137]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[864.085,480.318]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1287.74,474.92]]
    },],[{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[388.711,426.549]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[418.719,618.247]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[428.726,484.199]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[457.899,490.6]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[464.59,475.583]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[598.938,528.883]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[860.49,481.322]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1280.88,485.805]]
    },],[{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[387.888,602.149]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[429.209,418.561]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[441.045,474.379]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[475.2,481.273]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[483.797,466.956]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[585.657,521.116]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[856.121,480.731]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1272.98,494.937]]
    },],[{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[356.591,587.094]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[450.582,463.942]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[465.363,409.338]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[489.635,471.292]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[500.059,457.5]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[570.847,512.857]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[850.126,478.878]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1263.24,503.122]]
    },],[{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[325.12,572.182]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[458.025,452.965]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[498.362,399.317]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[501.837,460.79]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[514.018,447.425]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[554.337,504.022]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[841.603,476.186]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1249.02,511.045]]
    },],[{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[296.497,556.421]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[465.663,441.141]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[513.93,449.497]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[527.766,436.513]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[530.359,388.462]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[538.232,494.127]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[831.738,472.495]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1230,518.603]]
    },],[{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[273.886,539.24]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[475.634,428.39]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[524.842,482.906]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[527.885,437.353]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[543.234,424.747]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[563.171,376.911]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[822.018,467.732]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1206.35,525.553]]
    },],[{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[260.419,520.477]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[489.946,414.897]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[516.609,470.349]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[545.546,424.551]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[562.224,412.353]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[598.368,365.034]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[814.192,461.981]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1178.86,531.539]]
    },],[{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[258.668,500.418]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[510.268,401.103]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[515.79,456.739]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[568.462,411.531]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[586.254,399.795]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[637.184,353.417]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[810.092,455.504]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1149.06,536.151]]
    },],[{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[270.502,479.797]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[524.303,442.714]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[537.903,387.761]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[597.862,399.043]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[616.522,387.845]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[680.517,342.926]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[811.456,448.772]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1119.17,539.027]]
    },],[{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[296.639,459.741]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[543.356,429.216]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[573.554,375.857]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[634.432,388.065]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[653.696,377.492]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[728.778,334.577]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[819.688,442.396]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1091.94,540.003]]
    },],[{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[336.695,441.63]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[573.335,417.423]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[617.299,366.531]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[678.278,379.726]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[697.867,369.856]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[781.898,329.406]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[835.741,437.107]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1070.19,539.226]]
    },],[{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[386.014,425.831]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[611.369,407.425]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[666.699,359.488]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[727.262,373.731]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[746.964,364.577]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[838.291,326.677]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[858.295,432.763]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1054.81,537.128]]
    },],[{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[439.61,411.835]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[654.017,398.63]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[719.047,353.731]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[778.973,369.085]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[798.667,360.581]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[885.318,428.809]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[896.415,324.945]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1045.15,534.225]]
    },],[{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[496.108,399.719]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[700.274,391.228]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[773.62,349.348]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[832.724,365.804]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[852.349,357.839]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[916.249,425.448]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[956.072,324.147]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1041.07,531.022]]
    },],[{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[554.423,389.475]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[749.239,385.345]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[829.789,346.344]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[887.968,363.795]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[907.538,356.252]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[950.488,422.864]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[1017.15,324.275]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1042.09,527.952]]
    },],[{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[613.688,381.011]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[800.102,381.02]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[887.034,344.616]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[944.333,362.907]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[963.921,355.7]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[987.42,421.182]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1047.51,525.365]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[1079.6,325.322]]
    },],[{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[673.293,374.243]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[852.177,378.269]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[944.991,344.07]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1001.59,363.077]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1021.29,356.156]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1026.45,420.52]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1056.49,523.517]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[1143.37,327.343]]
    },],[{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[732.767,369.048]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[904.859,377.02]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1003.41,344.59]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1059.58,364.264]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1068.09,522.591]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1067.02,420.936]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1079.49,357.604]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[1208.48,330.364]]
    },],[{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[791.781,365.336]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[957.649,377.17]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1062.12,346.123]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1081.37,522.695]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1108.58,422.485]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1118.16,366.492]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1138.39,360.079]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[1274.93,334.446]]
    },],[{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[850.077,363.015]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1010.14,378.568]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1095.37,523.877]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1120.98,348.636]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1150.6,425.185]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1177.19,369.781]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1197.83,363.608]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[1342.75,339.64]]
    },],[{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[907.445,362.043]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1062.02,381.099]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1109.12,526.127]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1179.86,352.151]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1192.56,429.063]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1236.51,374.192]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1257.67,368.252]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[1411.95,346.043]]
    },],[{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[963.675,362.346]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1113,384.626]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1121.69,529.384]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1233.92,434.094]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1238.59,356.653]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1295.98,379.732]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1317.75,374.025]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[1482.59,353.71]]
    },],[{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1018.55,363.875]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1132.15,533.535]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1162.83,389.076]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1274.12,440.257]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1297.01,362.16]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1355.37,386.443]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1377.87,380.971]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[1554.65,362.742]]
    },],[{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1071.83,366.546]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1139.61,538.415]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1211.23,394.387]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1312.54,447.499]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1354.88,368.684]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1414.47,394.349]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1437.79,389.121]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[1628.1,373.246]]
    },],[{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1123.24,370.246]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1143.2,543.804]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1257.85,400.52]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1348.52,455.75]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1411.91,376.245]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1472.92,403.489]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1497.16,398.52]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[1702.79,385.356]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1142.12,549.467]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1172.53,374.797]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1302.35,407.402]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1381.33,464.883]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1467.74,384.827]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1530.34,413.857]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1555.59,409.171]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[1778.51,399.182]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1135.16,555.383]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1219.47,380.035]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1344.27,414.966]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1410.19,474.73]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1521.9,394.42]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1586.17,425.452]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1612.49,421.078]]
    },{
    name:"Club Deportivo Rivera",
    tipo:"Club Deportivo Rivera",
    verts:[[1854.8,414.855]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1106.48,546.447]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1263.87,385.78]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1383.16,423.08]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1434.34,485.045]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1573.83,404.951]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1639.79,438.203]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1667.23,434.179]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1093.29,543.94]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1305.56,391.866]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1418.57,431.576]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1453.04,495.514]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1622.94,416.306]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1690.48,451.991]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1719.02,448.361]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1072.58,545.466]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1343.74,399.159]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1449.24,441.156]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1464.69,506.447]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1667.35,429.246]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1736.12,467.48]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1765.63,464.288]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1047.01,546.484]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1377.68,408.185]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1474.08,452.196]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1468.17,517.945]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1705.4,444.144]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1774.78,484.955]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1805.01,482.234]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1017.96,546.599]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1407.43,418.322]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1463.78,529.399]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1493.15,464.066]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1736.87,460.326]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1806.14,503.737]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1836.78,501.515]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[986.802,545.712]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1433.3,429.025]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1452.27,540.34]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1506.79,476.235]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1761.88,477.222]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1830.21,523.268]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1860.94,521.563]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[954.852,543.862]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1434.73,550.477]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1455.82,439.848]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1515.67,488.298]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1780.94,494.411]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1847.49,543.158]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1877.93,541.987]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[923.249,541.153]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1412.41,559.688]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1475.68,450.496]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1520.62,500.018]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1794.84,511.667]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1858.72,563.231]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1888.52,562.614]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[892.89,537.723]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1386.69,568.021]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1493.79,460.79]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1522.68,511.301]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1804.72,528.967]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1865.07,583.553]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1893.89,583.517]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[864.405,533.706]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1358.88,575.655]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1511.18,470.687]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1523.02,522.209]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1811.99,546.511]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1868,604.452]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1895.54,605.045]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[838.138,529.213]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1330.24,582.911]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1522.93,532.954]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1529.09,480.261]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1818.4,564.764]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1869.34,626.587]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1895.36,627.894]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[812.834,524.097]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1299.78,589.904]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1521.76,543.699]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1547.16,489.612]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1823.37,584.202]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1868.34,650.604]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1892.54,652.749]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[787.902,518.035]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1266,596.398]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1517.95,554.492]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1564.25,498.923]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1824.46,605.07]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1862.15,676.723]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1884.05,679.84]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[764.568,510.903]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1229.27,602.197]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1511.32,565.436]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1580.34,508.485]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1820.56,627.593]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1849.31,705.072]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1868.25,709.284]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[744.042,502.68]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1190.2,607.086]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1501.74,576.575]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1595.33,518.562]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1810.44,651.84]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1828.24,735.555]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1843.37,740.951]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[727.487,493.468]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1149.58,610.824]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1489.03,587.88]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1608.97,529.397]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1792.63,677.629]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1797.15,767.689]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1807.46,774.286]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[715.883,483.511]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1108.37,613.212]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1473.07,599.267]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1620.89,541.201]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1754.42,800.603]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1758.76,808.299]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1765.67,704.501]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[710.01,473.215]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1067.52,614.068]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1453.62,610.56]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1630.42,554.131]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1695.66,841.322]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1698.47,832.807]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1727.92,731.557]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[710.295,463.135]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[1027.86,613.249]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1430.5,621.523]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1617.36,871.168]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1628.39,862.329]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1636.66,568.253]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1678.06,757.508]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[716.781,453.941]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[989.923,610.409]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1403.44,631.847]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1524.11,895.212]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1544.09,886.765]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1615.17,780.669]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1638.37,583.493]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[727.79,445.554]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[953.482,604.463]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1372.55,641.279]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1418.46,912.878]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1447.66,905.554]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1540.38,800.462]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1635.14,599.422]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[741.697,437.455]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[920.56,595.071]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1303.85,924.87]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1338.43,649.751]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1342.13,919.338]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1455.92,817.199]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1627.4,615.702]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[758.32,429.722]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[893.05,585.3]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1183.24,930.193]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1229.99,927.228]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1301.49,657.157]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1363.22,830.229]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1614.92,632.22]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[777.466,422.425]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[869.673,576.415]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[1060.37,927.911]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[1114.3,928.35]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1262.15,663.408]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1264.06,838.872]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1597.47,648.849]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[798.903,415.608]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[849.724,567.97]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[939.858,917.958]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[998.901,922.302]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1160.54,842.405]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1220.81,668.452]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1574.94,665.484]]
    },],[{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[822.431,409.326]]
    },{
    name:"Spa",
    tipo:"Spa",
    verts:[[826.139,901.704]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[833.104,559.635]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[887.944,909.643]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[1055.33,839.805]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1177.71,672.143]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1547.14,681.972]]
    },],[{
    name:"Spa",
    tipo:"Spa",
    verts:[[721.896,881.397]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[784.633,892.222]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[819.761,551.331]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[847.83,403.614]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[952.265,830.84]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1132.95,674.184]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1513.96,698.184]]
    },],[{
    name:"Spa",
    tipo:"Spa",
    verts:[[628.277,858.41]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[690.574,871.657]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[809.602,543.076]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[855.064,817.157]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[874.902,398.519]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1086.62,673.784]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1475.24,713.93]]
    },],[{
    name:"Spa",
    tipo:"Spa",
    verts:[[545.867,833.453]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[606.499,848.879]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[765.34,800.992]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[802.455,534.933]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[903.447,394.079]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[1039.66,669.711]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1430.87,729.01]]
    },],[{
    name:"Spa",
    tipo:"Spa",
    verts:[[475.066,806.909]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[532.905,824.308]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[683.478,783.204]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[798.116,526.971]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[933.276,390.36]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[994.645,661.826]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1380.65,743.094]]
    },],[{
    name:"Spa",
    tipo:"Spa",
    verts:[[415.829,779.317]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[469.941,798.438]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[609.787,764.034]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[796.304,519.265]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[964.181,387.396]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[953.553,652.579]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1324.52,755.825]]
    },],[{
    name:"Spa",
    tipo:"Spa",
    verts:[[367.867,751.118]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[417.535,771.671]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[544.654,743.559]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[796.735,511.872]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[915.72,643.988]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[995.959,385.247]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1262.43,766.573]]
    },],[{
    name:"Spa",
    tipo:"Spa",
    verts:[[330.587,722.751]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[375.329,744.425]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[488.308,721.983]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[799.101,504.845]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[879.99,636.203]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1028.39,383.975]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1194.65,774.405]]
    },],[{
    name:"Spa",
    tipo:"Spa",
    verts:[[303.295,694.565]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[342.833,717.047]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[440.833,699.535]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[803.106,498.221]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[845.866,628.732]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1061.23,383.663]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1122.32,778.262]]
    },],[{
    name:"Spa",
    tipo:"Spa",
    verts:[[285.075,666.907]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[319.315,689.901]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[402.03,676.539]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[808.429,492.03]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[813.248,621.187]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[1047.59,778.092]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1094.19,384.367]]
    },],[{
    name:"Spa",
    tipo:"Spa",
    verts:[[275.093,640.011]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[304.086,663.242]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[371.646,653.256]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[782.23,613.299]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[814.785,486.291]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[972.159,774.981]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1126.95,386.167]]
    },],[{
    name:"Spa",
    tipo:"Spa",
    verts:[[272.387,614.107]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[296.297,637.331]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[349.192,629.989]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[752.935,604.939]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[821.873,481.007]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[896.691,769.802]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1159.14,389.089]]
    },],[{
    name:"Spa",
    tipo:"Spa",
    verts:[[276.031,589.365]]
    },{
    name:"Área de piscina",
    tipo:"Área de piscina",
    verts:[[295.109,612.372]]
    },{
    name:"Club La Rivera",
    tipo:"Club La Rivera",
    verts:[[334.099,607.004]]
    },{
    name:"Jardín La Pradera",
    tipo:"Jardín La Pradera",
    verts:[[725.51,596.042]]
    },{
    name:"Circuito deportivo",
    tipo:"Circuito deportivo",
    verts:[[821.765,762.535]]
    },{
    name:"Oratorio",
    tipo:"Oratorio",
    verts:[[829.413,476.168]]
    },{
    name:"Área de Parques",
    tipo:"Área de Parques",
    verts:[[1190.34,393.13]]
    },],]
let amenitiess = []

interface Billboards{
    billboard: any
}

interface Props{
    amenity: any,
    angle: number,
    gallery: any,
    openGallery: any,
    show: boolean,
    secondaryBtnSelected:any,
    leftOffset: number,
    zoom: number,
    topOffset: number
}

interface State{
    angle: number,
    pos: any,
    transition: boolean
}

class Billboards extends React.Component<Props, State>{
    constructor(props: Props){
        super(props)
        this.state = {
            angle: 0,
            pos: [],
            transition: false
        }
    }

    
    createBillboards = () => {
        
        if(this.props.secondaryBtnSelected !== ''){
            if(Amenities[this.props.angle].length > 0){
                
                for(let i = 0; i < Amenities[this.props.angle].length; i++)
                {
                    if(Amenities[this.props.angle][i].name === this.props.secondaryBtnSelected){
                        this.billboard = <svg 
                        width={"100%"}
                        height={"100%"}
                        preserveAspectRatio="xMidYMid slice"
                        viewBox="0 0 1920 1080"
                        style={{
                            overflow: 'hidden',
                            pointerEvents: 'none',
                            position: 'absolute'
                        }}>
                                <g style={{
                                    pointerEvents: this.props.show ? 'visibleFill':'none'
                                }}
                                onClick = { this.props.gallery.length > 0  ? this.props.openGallery :null }
                                onTouchStart = {this.props.gallery.length > 0 ? this.props.openGallery:null }
                                >
                            <rect className={this.props.gallery.length > 0? 'content-text': 'fade-out'} rx="10" ry="10"  x={Amenities[this.props.angle][i].verts[0][0]-75}
                            y={Amenities[this.props.angle][i].verts[0][1]-70} width="11%" height="2.5%" style={{fill:"#418c5ab4"}} />
                                <text 
                            x={Amenities[this.props.angle][i].verts[0][0]-57}
                            y={Amenities[this.props.angle][i].verts[0][1]-50}  style = {{
                                fill:"#ffffff",
                                stroke:"#ffffff",
                                strokeWidth:1}} className={"text-gallery"}>{this.props.gallery.length > 0? "Toca para ver galería": ""}</text>
                                    <circle 
                                        cx={Amenities[this.props.angle][i].verts[0][0]-10} 
                                        cy={Amenities[this.props.angle][i].verts[0][1]-10} 
                                        r="30" 
                                        style = {{
                                            fill:"rgba(90,89,92,.85)",
                                            stroke:"rgba(255,255,255,.85)",
                                            strokeWidth:1
                                        }}
                                        />
                                    <image 
                                        href={icons[this.props.secondaryBtnSelected + '2']}
                                        width="30"
                                        height="30"
                                        x={Amenities[this.props.angle][i].verts[0][0]-25}
                                        y={Amenities[this.props.angle][i].verts[0][1]-25}
                                        /*style={{
                                            position: 'absolute',
                                            left:this.state.pos[0],
                                            top:this.state.pos[1]
                                        }}*/
                                        
                                        ></image>
                                </g>
                                
                            </svg>;
                        //})
                        break;
                    }                    
                }
            } 
            // else
            // {
            //     this.billboard = <div></div>
            // }
            
        }
    }
    
    componentDidUpdate(prevProps: any){
        if(mobileAndTabletCheck() && window.innerHeight > window.innerWidth){
            barOffset = 5;
            imageSize = ['calc(84% * 1.77778)', '84%'];
        }
        else {
          imageSize = ['100%', '100%'];
          barOffset = 0;
        }
  
        // TODO: check if this routine can be optimized
        
        if(!this.props.show){
            return
        } 


        if(prevProps.amenity !== this.props.amenity){
            this.setState({transition:true})
            setTimeout(function(this: any){
                this.setState({
                    transition: false,
                })
                this.createBillboards();
                this.forceUpdate();   
            }.bind(this), 250)
        }
                
        if(prevProps.angle !== this.props.angle || prevProps.show !== this.props.show){
            this.createBillboards();
            this.forceUpdate();        
        }
    }
  
    render() {
        return (
            <div
                style={{
                    pointerEvents: 'none',
                    width: imageSize[0],
                    height: imageSize[1],
                    transform: 'scale('+this.props.zoom+') translate(calc(' + this.props.leftOffset + '%), calc(' + barOffset + '% + ' + this.props.topOffset + '%))'
                }}
                className={this.props.show && !this.state.transition ? "billboards fade-in":"billboards fade-out"}
            >
                {this.billboard}
            </div>
            
        );
      
    }

}

export default Billboards